import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class MonthlyDistanceLimitStore {
  monthlyDistanceLimitData = [];

  total = 0;
  loading = false;
  rootStore;
  loadingData = false;
  pageSize = 0;

  constructor(rootStore) {
    makeObservable(this, {
      monthlyDistanceLimitData: observable,
      pageSize: observable,
      total: observable,
      loading: observable,
      loadingData: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,

    fromDate,
    toDate,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=monthlyDistanceLimit",
        "postData=" + base64Input
      );
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.monthlyDistanceLimitData = response?.data?.data?.monthlyDistanceData;
    this.loading = false;
  }

  async exportExcel(getData) {
    let lang = "english";

    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmonthlyDistanceLimitExcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&userId=" +
      getData.userId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportpdf(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportmonthlyDistanceLimitPdf&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}
export default MonthlyDistanceLimitStore;
